module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_shinai-f643369fe9abc0e860bea5422f9f9eb1.png";